export default {
  path: '/login',
  component: () => import('@/components/pages/Login.vue')
}
